export enum HeadlinesStatusEnum {
  all = 'All',
  solved = 'Solved',
  unsolved = 'Unsolved',
}
